import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Icon } from 'antd';


const propTypes = {
    message: PropTypes.string,
    variant: PropTypes.oneOf([
        'error',
        'success',
        'default',
    ]),
    icon: PropTypes.string,
};

const { Text } = Typography;

const StatusMessage = ({ message = '',  icon = '', variant = 'default' }) => {
    if (!message) return null;

    if (variant === 'error') {
        return (
            <Text type="danger">
                <Icon type="exclamation-circle" />
                { ` ${message}` }
            </Text>
        );
    }

    if (variant === 'success') {
        return (
            <Text style={{ color: '#52c41a' }}>
                <Icon type="check-circle" />
                { ` ${message}` }
            </Text>
        );
    }

    return (
        <Text>
            <Icon type={icon} />
            { ` ${message}` }
        </Text>
    );
};

StatusMessage.propTypes = propTypes;

export default StatusMessage;
